import { render, staticRenderFns } from "./NotificationTemplates.vue?vue&type=template&id=28933a25&scoped=true"
import script from "./NotificationTemplates.vue?vue&type=script&lang=js"
export * from "./NotificationTemplates.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplates.vue?vue&type=style&index=0&id=28933a25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28933a25",
  null
  
)

export default component.exports